import { InputAdornment } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React, { Component } from 'react';

import TextfieldWrapper from './textFeild';

export class InputField extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }
    sendDataToInput = (e) => {
      if (this.props?.getInputData) {
        this.props.getInputData(e);
      }
    };
    render() {
        const {
            errors,
            values,
            name,
            touched,
            placeholder,
            disable,
            required,
            multiline,
            type,
            marginTop,
            marginBottom
        } = this.props;
        return (
          <TextfieldWrapper
            name={name}
            type={type}
            label={placeholder}
            required={required}
            disabled={disable}
            multiline={multiline}
           sendDataToInput={this.sendDataToInput}
            sendDataOnBlur={this.props.sendDataOnBlur}
            rows={5}
            style={{ marginTop:marginTop?marginTop:'12px', marginBottom:marginBottom?marginBottom: '9px' }}
            InputProps={
              errors && touched
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <ErrorOutlineIcon
                          style={{ color: 'red' }}
                        ></ErrorOutlineIcon>
                      </InputAdornment>
                    )
                  }
                : values?.length > 0
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <CheckIcon style={{ color: 'green' }}></CheckIcon>
                      </InputAdornment>
                    )
                  }
                : {}
            }
          />
        );
    }
}

export default InputField;
